$(document).ready(function() {

  function format(api, rowIdx, columns) {
    var data = $.map(columns, function(col, i) {
      return col.hidden ?
        '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
        '<td><b>' + col.title + '</b></td> ' +
        '<td>' + col.data + '</td>' +
        '</tr>' :
        '';
    }).join('');
    return data ? '<div class="dtableslider"><table>' + data + '</table></div>' : undefined;
  }

  var table = $('.ce-table').DataTable({
    "info": false,
    "ordering": true,
    "paging": false,
    "searching": false,
    columnDefs: [{
      width: '20%',
      targets: 0
    }],
    responsive: {
      details: {
        renderer: function(api, rowIdx, columns) {
          var data = format(api, rowIdx, columns);
          return data ?
            data :
            false;
        },
        display: function(row, update, render) {
          if (update) {
            if ($(row.node()).hasClass('parent')) {
              row.child(render(), 'child').show();
              $('div.dtableslider', row.child()).slideDown(0);
              return true;
            }
          } else {
            if (!row.child.isShown()) {
              row.child(render(), 'child').show();
              $(row.node()).addClass('parent shown');
              $('div.dtableslider', row.child()).slideDown();

              return true;
            } else {
              $('div.dtableslider', row.child()).slideUp(function() {
                row.child(false);
                $(row.node()).removeClass('parent shown');
              });

              return false;
            }
          }

        }
      }
    }
  });

});